import {
  SET_TRANSIENT_SLOT_ID,
  RESET_BOOKING_STATE,
  UPDATE_PACKAGE_CHOICE,
  RESET_PACKAGE_CHOICE,
  UPDATE_STUDENT,
  UPDATE_ADMIN_STUDENT,
  UPDATE_PACKAGE_SELECT_SKIPPED,
  SCHEDULE_FETCH_ERROR,
  OUT_OF_SERVICE_AREA,
  SET_PRICE_BREAKDOWN,
} from "../actions/types"
import type {
  UpdatePackageSelectSkippedAction,
  UpdatePackageChoiceAction,
  UpdateStudentAction,
  UpdateAdminStudentAction,
  ResetPackageChoiceAction,
  ResetBookingStateAction,
  ResetAvailsAction,
  SetPriceBreakdownAction,
} from "../actions/bookingActions"
import { PriceBreakdown, ProductPackageWithPrices, User } from "../types"
import type { SetTransientSlotIdAction } from "../actions/lessonActions"
import {
  SetIsOutOfServiceAreaAction,
  SetSchedulerFetchErrorAction,
} from "../actions/searchActions"

interface ReduxBookingState {
  transientSlotId: string | null
  packageChoice: ProductPackageWithPrices | null
  student: User | null
  adminStudent: User | null
  packageSelectSkipped: boolean
  slots: null // is this field used at all?
  errors: string | null
  outOfServiceArea: boolean
  priceBreakdown: PriceBreakdown | null
}

const INITIAL_STATE: ReduxBookingState = {
  transientSlotId: null,
  packageChoice: null,
  student: null,
  adminStudent: null,
  packageSelectSkipped: false,
  slots: null,
  errors: null,
  outOfServiceArea: false,
  priceBreakdown: null,
}

type Actions =
  | UpdatePackageSelectSkippedAction
  | UpdatePackageChoiceAction
  | UpdateStudentAction
  | UpdateAdminStudentAction
  | ResetPackageChoiceAction
  | ResetBookingStateAction
  | SetPriceBreakdownAction
  | ResetAvailsAction
  | SetIsOutOfServiceAreaAction
  | SetSchedulerFetchErrorAction
  | SetTransientSlotIdAction

export default (state = INITIAL_STATE, action: Actions): ReduxBookingState => {
  switch (action.type) {
    case SET_TRANSIENT_SLOT_ID:
      return { ...state, transientSlotId: action.payload }
    case RESET_BOOKING_STATE:
      // Don't reset the adminStudent or the transient.
      return {
        ...INITIAL_STATE,
        adminStudent: state.adminStudent,
        transientSlotId: state.transientSlotId,
      }
    case UPDATE_PACKAGE_CHOICE:
      return { ...state, packageChoice: action.payload }
    case RESET_PACKAGE_CHOICE:
      return { ...state, packageChoice: null }
    case UPDATE_STUDENT:
      return { ...state, student: action.payload }
    case UPDATE_ADMIN_STUDENT:
      return { ...state, adminStudent: action.payload }
    case UPDATE_PACKAGE_SELECT_SKIPPED:
      return { ...state, packageSelectSkipped: action.payload }
    case SCHEDULE_FETCH_ERROR:
      return { ...state, errors: action.payload }
    case OUT_OF_SERVICE_AREA:
      return { ...state, outOfServiceArea: true }
    case SET_PRICE_BREAKDOWN:
      return { ...state, priceBreakdown: action.payload }
    default:
      return state
  }
}
